import { render } from "./UpdateTurns.vue?vue&type=template&id=7938f709"
import script from "./UpdateTurns.vue?vue&type=script&lang=js"
export * from "./UpdateTurns.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__